import script from "./StatementAsset.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementAsset.vue?vue&type=script&setup=true&lang=js"

import "./StatementAsset.vue?vue&type=style&index=0&id=1cc2c9f7&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc2c9f7"]])

export default __exports__